import React from 'react';

export let GEO_CMS_API_BASE_URL = 'https://www.geocms.it/API/geocms/';

export let GEOCMS_API = {
	license:
		'6178612d6974616c69612e69743b70702d6178612d6974616c69612d69742e6178612d61737369637572617a696f6e692d69742e696e74726178613b7376696c7777772e6178612d61737369637572617a696f6e692d69742e696e74726178613b746573747777772e6178612d61737369637572617a696f6e692d69742e696e7472617861-4158412d4974616c6961-1f4-1330243-7374616e64617264-0',
	apiVersion: '3',
	project: 'AgencyLocator',
	modules: 'infobubble'
};

export function setGeoCMSApiBaseURL(geoCMSApiBaseURL) {
	GEO_CMS_API_BASE_URL = geoCMSApiBaseURL;
}

export function setGeoCMSApiLicense(geoCMSApiLicense) {
	GEOCMS_API.license = geoCMSApiLicense;
}

export function setGeoCMSApiVersion(geoCMSApiVersion) {
	GEOCMS_API.apiVersion = geoCMSApiVersion;
}

export const SEARCH_RADIUS = 50000;
export const RANKED_SEARCH_RADIUS = 30000;

export const PAGE_LANDING = 'landing';
export const PAGE_SERP_MAP = 'map';
export const PAGE_SERP_LIST = 'list';
export const PAGE_CALCULATE_ROUTE = 'calculate-route';
export const PAGE_STREET_VIEW = 'street-view';
export const MOBILE_INFOWINDOW_VIEW = 'mobile-infowindow-view';

// Agenzie
export const AGENCY_PROJECT = 'AgencyLocator';
export const SUB_AGENCY_PROJECT = 'SubAgenti';

// Filiali MPS
export const FILIALI_PROJECT = 'MPSLocator';

// Carrozzerie convenzionate
export let PROJECT_CAR = 'Carrozzerie';
export const PROJECT_CAR2 = 'Carrozzerie';

export function setProjectCar(projectCar) {
	PROJECT_CAR = projectCar;
}

// Cristalli e grandine
export const PROJECT_CRI = 'Cristalli';
export const PROJECT_GRA = 'Grandine';

export const PROJECT_CCG = 'CarGlass';
export const PROJECT_CGL = 'Glassdrive';
export const PROJECT_CMO = 'Motorglass';
export const PROJECT_CVC = 'Vetrocar';
export const PROJECT_CCC = 'Carclinic';
export const PROJECT_CGR = 'MaestriDellaGrandine';
export const PROJECT_SOS = 'SOSGrandine'; // al momento è dsabilitato
export const PROJECT_DOG = 'DottorGrandine';
export const PROJECT_BSG = 'Ballsystem';
export const PROJECT_LTG = 'LeverTouch';
export const PROJECT_EUG = 'Eurograndine';
export const PROJECT_HGG = 'HailGuard';
export const PROJECT_UGG = 'UpGrandine';
export const PROJECT_ASG = 'Autosicura';
export const PROJECT_ING = 'Inova';
export const PROJECT_NSG = 'NSG';
export const PROJECT_STS = 'StormSolution'

// export const CURRENT_GRA_LIST = [PROJECT_CCC, PROJECT_CGR, PROJECT_DOG];

export const CURRENT_CRI_LIST = [PROJECT_CCG, PROJECT_CGL, PROJECT_CVC];

export const CURRENT_GRA_LIST = [
	PROJECT_CCC,
	PROJECT_CGR,
	PROJECT_DOG,
	PROJECT_BSG,
	PROJECT_LTG,
	PROJECT_EUG,
	PROJECT_HGG,
	PROJECT_UGG,
	PROJECT_ASG,
	PROJECT_ING,
	PROJECT_NSG,
	PROJECT_STS
];

export const GRA_LOGOS = {
	[PROJECT_CCC]: 'carclinic_logo.png',
	[PROJECT_CGR]: 'maestridellagrandine_logo.png',
	[PROJECT_DOG]: 'dottorgrandine_logo.jpg',
	[PROJECT_BSG]: 'ballsystem_logo.png',
	[PROJECT_LTG]: 'lever_touch_logo.png',
	[PROJECT_EUG]: 'eurograndine_logo.png',
	[PROJECT_HGG]: 'hail_guard_logo.png',
	[PROJECT_UGG]: 'up_grandine_logo.png',
	[PROJECT_ASG]: 'autosicura_logo.png',
	[PROJECT_ING]: 'inova_logo.png',
	[PROJECT_NSG]: 'nonsolograndine_logo.png',
	[PROJECT_STS]: 'stormsolution_logo.png'
};

export const PROJECT_GOOGLE = 'GooglePlaces';

export const CTA_CVC = 'https://vetrocar.it/convenzioni/axa/';
export const SITE_CVC = 'https://www.vetrocar.it/intervento-immediato';

export const SOS_PHONE = '800 271611';

export const DOG_SITE = 'https://www.dottorgrandine.com/';

// Centri salute e vita
export let PROJECT_CSV = 'CentriSaluteVita';
// Nuovi centri salute
export const PROJECT_CSV2 = 'NuoviCentriSalute';

export function setProjectCsv(projectCsv) {
	PROJECT_CSV = projectCsv;
}

// export const TABS_TO_DISPLAY = [
// 	AGENCY_PROJECT,
// 	PROJECT_CAR,
// 	PROJECT_CRI,
// 	PROJECT_CSV,
// 	'Ristoranti'
// ];

export const CAR_TYPES = {
	NETWORK_AXA: 'Network Axa',
	CARCLINIC: 'Carclinic',
	SOLUZIONE_CARROZZERIE: 'Soluzione Carrozzerie',
	METAFORA: 'METAFORA',
	AUTOSICURA: 'autosicura',
	RIPARTE: 'RIPARTE'
};

// export const TABS = [
// 	{
// 		key: AGENCY_PROJECT,
// 		label: 'Agenzie',
// 		icon: 'icon/agente_blue.png',
// 		tcEventName: 'SEZIONE_TROVAAGENTE'
// 	},
// 	{
// 		key: PROJECT_CAR,
// 		label: 'Carrozzerie',
// 		icon: 'icon/carrozzerie_blue.png',
// 		tcEventName: 'SEZIONE_CARROZZERIECONVENZIONATE'
// 	},
// 	{
// 		key: PROJECT_CRI,
// 		label: 'Cristalli e Grandine',
// 		icon: 'icon/cristalli_blue.png',
// 		tcEventName: 'SEZIONE_CRISTALLI_GRANDINE'
// 	},
// 	{
// 		key: PROJECT_CSV,
// 		label: 'Centri salute',
// 		icon: 'icon/salute_vita_blue.png',
// 		tcEventName: 'SEZIONE_CENTRISALUTE'
// 	}
// ];

export const RESTURANTS = 'Ristoranti';

export const FUEL = 'Fuel';

export const DATA_SRC_TYPES = {
	GeoCMS: 'GeoCMS',
	URL: 'URL',
	GooglePlaces: 'GooglePlaces'
};

// export const SHOW_ALL = false;

export const RANKING = 'QUOTATORE AUTO';

export const PHOTOS_BASE_PATH = 'https://prodigio-cms.it/';

export const CHAR_SEPARATOR = '--';

export const TRAVEL_MODES = {
	DRIVING: 0,
	TRANSIT: 1,
	WALKING: 2
};

export const CAR_SERVICES = [
	{
		name: 'AutoSostitutiva',
		icon: 'services/auto_blue.png',
		tooltip: 'Auto di cortesia durante la riparazione'
	},
	{
		name: 'Gommista',
		icon: 'services/gommista_blue.png',
		tooltip: 'Gommista'
	},
	{
		name: 'InterventiElettronica',
		icon: 'services/interventi_elettronica_blue.png',
		tooltip: 'Interventi Elettronica'
	},
	{
		name: 'InterventiMeccanica',
		icon: 'services/meccanico_blue.png',
		tooltip: 'Interventi Meccanica'
	},
	{
		name: 'InterventiSmart',
		icon: 'services/interventi_smart_blue.png',
		tooltip: 'Interventi Smart'
	},
	{
		name: 'PickupAndDelivery',
		icon: 'services/pickup_and_delivery_blue.png',
		tooltip: 'Ritiro e riconsegna veicolo entro i 20 km'
	},
	{
		name: 'Revisioni',
		icon: 'services/check_in_blue.png',
		tooltip: 'Revisione veicoli'
	},
	{
		name: 'RicaricaCondizionatori',
		icon: 'services/ricarica_condizionatori_blue.png',
		tooltip: 'Ricarica Condizionatori'
	},
	{
		name: 'RiparazioniSpot',
		icon: 'services/riparazioni_spot_blue.png',
		tooltip: 'Riparazioni Spot'
	},
	{
		name: 'RiparazioniVeicoliParticolari',
		icon: 'services/riparazioni_veicoli_particolari_blue.png',
		tooltip: 'Riparazioni Veicoli Particolari'
	},
	{
		name: 'SoccStradale',
		icon: 'services/carroattrezzi_blue.png',
		tooltip: 'Soccorso stradale entro i 20 km'
	}
	// {
	// 	name: 'Certificazione Green',
	// 	icon: 'services/foglia.png',
	// 	tooltip: 'Certificazione Green'
	// },
	// {
	// 	name: 'Certificazione Asseverazione',
	// 	icon: 'services/logo_asseverato_blu_bold.png',
	// 	tooltip: 'Certificazione Asseverazione'
	// }
];

export const CAR_CERTIFICATIONS = [
	{
		name: 'BMW MINI',
		icon: 'services/logo_bmw_mini.png',
		text: 'Riparazioni dedicate esclusivamente a veicoli BMW e MINI'
	},
	{
		name: 'Certificazione Green',
		icon: 'services/foglia.png',
		text: 'Struttura con certificazioni Green'
	},
	{
		name: 'AXA Assistance',
		icon: 'services/soccorso_stradale_axa.svg',
		text: 'Struttura convenzionata con il soccorso stradale AXA'
	},
	{
		name: 'Certificazione Asseverazione',
		icon: 'services/logo_asseverato_blu_bold.png',
		text: (
			<>
				Struttura{' '}
				<a href="https://asseverato.it/" target="_blank">
					asseverata
				</a>{' '}
				da Standard&Testing - Spin Off del Politecnico di Torino
			</>
		)
	},
	{
		name: 'Tesla approved',
		icon: 'services/logo_tesla_approved.png',
		text: 'Tesla Approved Body Shop'
	}
];

export const CSV_TYPES = {
	caseDiCura: {
		label: 'Case di Cura Convenzionate',
		class: 'CasediCuraConvenzionate'
	},
	centriSpecialistici: {
		label: 'Centri Specialistici Convenzionati',
		class: 'CentriSpecialisticiConvenzionati'
	},
	centriOdontoiatrici: {
		label: 'Centri Odontoiatrici',
		class: 'CentriOdontoiatrici'
	},
	ospedali: { label: 'Ospedale', class: 'Ospedali' }
};

export const PIN_PROP = {
	width: 41,
	height: 50,
	anchorX: 21,
	anchorY: 49,
	HIGHLIGHTED: {
		width: 61,
		height: 70,
		anchorX: 31,
		anchorY: 69
	},
	IMGs: {
		DEFAULT: {
			main: 'pin_red.png',
			highlighted: 'pin_red.png'
		},
		[AGENCY_PROJECT]: {
			main: 'pin_agenzie.png',
			highlighted: 'pin_agenzie_highlighted.png',
			off: 'pin_agenzie_disable.png'
		},
		[FILIALI_PROJECT]: {
			main: 'pin_mps.png',
			highlighted: 'pin_mps_highlighted.png'
		},
		[SUB_AGENCY_PROJECT]: {
			main: 'pin_subagenzie.png',
			highlighted: 'pin_subagenzie_highlighted.png'
		},
		[CAR_TYPES.NETWORK_AXA]: {
			main: 'pin_blue.png',
			highlighted: 'pin_blue_highlighted.png'
		},
		[CAR_TYPES.CARCLINIC + '_Carrozzerie']: {
			main: 'pin_red.png',
			highlighted: 'pin_red_highlighted.png'
		},
		[CAR_TYPES.SOLUZIONE_CARROZZERIE]: {
			main: 'pin_yellow.png',
			highlighted: 'pin_yellow_highlighted.png'
		},
		[CAR_TYPES.METAFORA]: {
			main: 'pin_brown.png',
			highlighted: 'pin_brown_highlighted.png'
		},
		[CAR_TYPES.AUTOSICURA]: {
			main: 'pin_autosicura.png',
			highlighted: 'pin_autosicura_highlighted.png'
		},
		[CAR_TYPES.RIPARTE]: {
			main: 'pin_riparte.png',
			highlighted: 'pin_riparte_highlighted.png'
		},
		[PROJECT_CCG]: {
			main: 'pin_carglass.png',
			highlighted: 'pin_carglass_highlighted.png'
		},
		[PROJECT_CGL]: {
			main: 'pin_glassdrive.png',
			highlighted: 'pin_glassdrive_highlighted.png'
		},
		[PROJECT_CVC]: {
			main: 'pin_vetrocar.png',
			highlighted: 'pin_vetrocar_highlighted.png'
		},
		[PROJECT_CCC]: {
			main: 'pin_carclinic.png',
			highlighted: 'pin_carclinic_highlighted.png'
		},
		[PROJECT_CGR]: {
			main: 'pin_maestri.png',
			highlighted: 'pin_maestri_highlighted.png'
		},
		[PROJECT_SOS]: {
			main: 'pin_sos_grandine.png',
			highlighted: 'pin_sos_grandine_highlighted.png'
		},
		[PROJECT_DOG]: {
			main: 'pin_dottor_grandine.png',
			highlighted: 'pin_dottor_grandine_highlighted.png'
		},
		[PROJECT_BSG]: {
			main: 'pin_ballsystem.png',
			highlighted: 'pin_ballsystem_highlighted.png'
		},
		[PROJECT_LTG]: {
			main: 'pin_levertouch.png',
			highlighted: 'pin_levertouch_highlighted.png'
		},
		[PROJECT_EUG]: {
			main: 'pin_eurograndine.png',
			highlighted: 'pin_eurograndine_highlighted.png'
		},
		[PROJECT_HGG]: {
			main: 'pin_hailguard.png',
			highlighted: 'pin_hailguard_highlighted.png'
		},
		[PROJECT_UGG]: {
			main: 'pin_upgrandine.png',
			highlighted: 'pin_upgrandine_highlighted.png'
		},
		[PROJECT_ASG]: {
			main: 'pin_autosicura.png',
			highlighted: 'pin_autosicura_highlighted.png'
		},
		[PROJECT_ING]: {
			main: 'pin_inova.png',
			highlighted: 'pin_inova_highlighted.png'
		},
		[PROJECT_NSG]: {
			main: 'pin_nonsolograndine.png',
			highlighted: 'pin_nonsolograndine_highlighted.png'
		},
		[PROJECT_STS]: {
			main: 'pin_stormsolution.png',
			highlighted: 'pin_stormsolution_highlighted.png'
		},
		[CSV_TYPES.caseDiCura.class]: {
			main: 'pin_protezione_salute.png',
			highlighted: 'pin_protezione_salute_highlighted.png'
		},
		[CSV_TYPES.centriOdontoiatrici.class]: {
			main: 'pin_odontoiatria.png',
			highlighted: 'pin_odontoiatria_highlighted.png'
		},
		[CSV_TYPES.centriSpecialistici.class]: {
			main: 'pin_specialistici_convenzionati.png',
			highlighted: 'pin_specialistici_convenzionati_highlighted.png'
		},
		[CSV_TYPES.ospedali.class]: {
			main: 'pin_semplicemente_vita.png',
			highlighted: 'pin_semplicemente_vita_highlighted.png'
		}
	}
};

export const WEB_FORM_EVENT_NAME = 'readGeoCMSParameters';
export const CLOSE_WEB_FORM_EVENT_NAME = 'closeWebForm';

export const TCLogTypes = {
	searchAddress: 'search-address',
	filter: 'filter'
};

export const TC_EVENT_NAMES = {
	USER_POSITION: 'POSIZIONE',
	SEARCH_ADDRESS: 'CERCA',
	SEL_SIDEBAR_AGENCY: 'SELEZIONA_AGENZIA_COLONNA',
	SEL_SIDEBAR_SUBAGENCY: 'SELEZIONA_SUBAGENZIA_COLONNA',
	SEL_SIDEBAR_CAR: 'SELEZIONA_CARROZZERIA_COLONNA',
	SEL_SIDEBAR_CSV: 'SELEZIONA_CENTRO_COLONNA',
	FILTER_AGENCY: 'FILTRI_AGENZIE',
	FILTER_SUBAGENCY: 'FILTRI_SUBAGENZIE',
	CONTACT_PARTNER: 'CONTATTA_PARTNER_',
	CALC_ROUTE: 'CALCOLA_PERCORSO',
	STREET_VIEW: 'STREET_VIEW',
	MAIL_AGENCY: 'MAIL_AGENZIA',
	MAIL_CAR: 'MAIL_CARROZZERIE',
	MAIL_CRI: 'MAIL_CRISTALLI'
};

// Sezione nuove carrozzerie
export const MOCK_CAR_URL =
	'http://localhost:8091/axa/getCarrozzerieasd?lat=${lat}&lng=${lng}';

export const PROJECT_CAR_NEW = 'NuoveCarrozzerie';

export const BRAND_STYLES = {
	CIRCLE: 'circle',
	LABEL: 'label'
};
